export default ({
    name : 'SideFix'
    , props : {
        'textColorStyle' : Object // common_header computed value.
    }
    , data () {
        return {
            categoryList : []
            , noticeUrl : '/notice'
            , qnaUrl : '/qna'
        }
    },
    created () {
        this.code = 'side_fix';
        this.basic = this.getDetailDataByCode(this.code);
        this.getCategoryList();
        // footer
        let footerData = this.getDetailDataByCode('common_footer');
        if (footerData.data.biz_info != undefined) {
            this.bizInfo = footerData.data.biz_info;
        }
        if (footerData.data.shop_info != undefined) {
            this.shopInfo = footerData.data.shop_info;
        }
        this.notice = this.getDetailDataByCode('notice');
        this.qna = this.getDetailDataByCode('qna');
        return {}
    },
	mounted () {
		this.publisher();
        this.setSideFixBgColor();
    },
    computed : {
        isUseShopBizHours () {
            return (this.isSetShopInfo() && this.shopInfo.shop_biz_hours.value.length > 0)
        }
        , isUseShopPhone () {
            return (this.isSetShopInfo() && this.shopInfo.shop_phone.value.length > 0)
        }
        , isUseShopEmail () {
            return (this.isSetShopInfo() && this.shopInfo.shop_email.value.length > 0)
        }
        , shopBizHours () {
            return this.shopInfo.shop_biz_hours.value;
        }
        , shopPhone () {
            return this.shopInfo.shop_phone.value;
        }
        , shopEmail () {
            return this.shopInfo.shop_email.value;
        }
        , linkShopPhone () {
            return "tel:" + this.shopInfo.shop_phone.value;
        }
        , linkShopEmail () {
            return "mailto:" + this.shopInfo.shop_email.value;
        }
        , profileBgColorStyle () {
            let backStyle = {}
            if (this.isSetBasicData('prf_bg_color') === true) {
                let prfBgColor = this.basic.data.prf_bg_color.value
                backStyle['backgroundColor'] = `#${prfBgColor}`
            }
            return backStyle
        }
        , profileLogoImg () {
            return this.basic.data.prf_logo.value
        }
        , shopName () {
            if (this.isSetBasicData('shop_name') === false) return this.shopNameDefault 
            if (this.basic.data.shop_name.value.length == 0) return this.basic.data.shop_name.default
            return this.basic.data.shop_name.value
        }
        , targetSohoSearch () {
            return this.getAdminEditMode() ? '' : '_blank'
        }
        /* link */
        , linkHome () {
            return this.getAdminEditMode() ? 'javascript:void(0);' : this.urlHome
        }
        , linkCart () {
            return this.getAdminEditMode() ? 'javascript:void(0);' : this.urlCart
        }
        , linkMyOrder () {
            return this.getAdminEditMode() ? 'javascript:void(0);' : this.urlMyOrder
        }
        , linkMyPage () {
            return this.getAdminEditMode() ? 'javascript:void(0);' : this.urlMyPage
        }
        , linkLogin () {
            return this.getAdminEditMode() ? 'javascript:void(0);' : this.urlLogin
        }
        , linkSohoSearchUrl () {
            return this.getAdminEditMode() ? 'javascript:void(0);' : this.urlSohoSearch
        }
        , isUseCategory : function () {
            if (this.basic.data.category_display.value.length < 1) { 
                return false
            }
            return true;
        }
        , isShowCategory : function () {
            if (this.categoryList.length > 0) return true
            return false
        }
        , isUseProfileLogo () {
            return this.isSetBasicData('prf_logo')
        }
        , isShowProfileLogo () {
            if (this.basic.data.prf_logo.value.length > 0) return true
            return false
        }
        , displayNotice() {
            return this.isSetNotice() ? this.notice.displayNotice : false;
        }
        , noticeListLink() {
            return (this.notice.displayNotice) ? this.noticeUrl : '';
        }
        , displayQna() {
            return this.isSetQna() ? this.qna.displayQna : false;
        }
        , qnaLink() {
            return (this.qna.displayQna) ? this.qnaUrl : '';
        }
    }
	, methods : {
		publisher () {
		
		}
        , isSetShopInfo () {
            return (typeof this.shopInfo != 'undefined')
        }
        , setSideFixBgColor () {
			let sideFixBgColor = 'fff';
            if (this.isSetBasicData('prf_bg_color') === true) {
				sideFixBgColor = this.basic.data.prf_bg_color.value
            }
			document.querySelector('.wrap').style.backgroundColor = `#${sideFixBgColor}`
            document.querySelector('#app').style.minHeight = '100%' 
            document.querySelector('#app').style.backgroundColor = `#${sideFixBgColor}`
        }
        /* category */
        , getCategoryList () {
            let params = new FormData()
			this.$http.post(`${this.baseURI}${this.displayDataUrl['category']}`, params, { headers : this.axiosCommonHeader }
            ).then(response => {
                if (response.data.length == 0) {
                    return
                }
                this.setCategoryList(response.data)
            }).catch(error => {
            })
        }
        , setCategoryList (data) {
            if (data.list.length == 0) {
                this.execCategoryListEmptyState()
                return
            }
            this.categoryList = data.list;
        }
        , execCategoryListEmptyState () {
            if (this.categoryList.length > 0) { // ex> 3 > 0 으로 저장.
                this.categoryList = [] 
            }
        }
        , checkCategoryDisplayChange () {
            let category        = this.basic.data.category_display.value
            let categoryIds     = []
            for (var i in category) {
                if ("ppc_id" in category[i] && category[i].ppc_menu_display == 'Y') {
                    categoryIds.push(category[i].ppc_id);
                }
            }
            if (categoryIds.length < 1) { 
                this.execCategoryListEmptyState()
                return false 
            }
            if (this.categoryList.length < 1 && categoryIds.length > 0) { return true }
            if (this.categoryList.length > categoryIds.length         ) { return true }

            let isMore = false
            let nowCategoryList = this.categoryList
            let categoryListIds = []
            for (var j in nowCategoryList) {
                if ("ppc_id" in nowCategoryList[j] && nowCategoryList[j].ppc_menu_display == 'Y') {
                    categoryListIds.push(nowCategoryList[j].ppc_id)
                }
            }
            for (var k in categoryIds) {
                if (categoryListIds.includes(categoryIds[k]) === false) {
                    isMore = true
                }
            }
            return isMore
        }
        , setCategoryListAdmin () {
            let category = this.basic.data.category_display.value
            let list = []
            for (let k in category) {
                let data = category[k]
                if ("ppc_id" in data && data.ppc_menu_display == 'Y') {
                    list.push(data)
                }
            }
            this.categoryList = list
        }
        , categoryMoveUrl (url) {
            if (this.getAdminEditMode()) { 
                return "javascript:void(0);"
            }
            return url
        }
        , categoryUrl (url) {
            if (this.getAdminEditMode()) { 
                return "javascript:void(0);"
            }
            return url
        }
        , isSetNotice () {
            return ((typeof this.notice != 'undefined') && this.notice.displayNotice)
        }
        , isSetQna () {
            return ((typeof this.qna != 'undefined') && this.qna.displayQna)
        }
		, goSearch () {
			//form 데이터 전달
			var keyword = $m('input[name="search_keyword"]').val();
			var blank = /^\s+|\s+$/g;
            if (keyword == '' || keyword == null || keyword.replace(blank,'') == "") {
                alert("검색어를 입력해주세요.");
                return false;
            }
			if (keyword.length > 250) {
				alert("최대 250자까지 입력 가능합니다.");
				return false;
			}
			return this.getAdminEditMode() ? '' : $m('#main_search_form').submit();
        }
        , isSubCategory : function (sub) {
            this.isSubDepth = false
            if (sub.length > 0) this.isSubDepth = true
            return this.isSubDepth
        }
        , linkCategory (url) {
            return this.isSubDepth ? 'javascript:void(0);' : url
        }
	}
    , updated () {
        if (this.getAdminEditMode() && this.isSetBasicData('category_display')) {
            if (this.checkCategoryDisplayChange()) {
                this.setCategoryListAdmin()
            }
        }
        this.setSideFixBgColor()
    }
})
